import React from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// DS tokens — order matters (fonts → colors → type → spacing → motion → base).
import '../design-source/ds/tokens/fonts.css';
import '../design-source/ds/tokens/colors.css';
import '../design-source/ds/tokens/typography.css';
import '../design-source/ds/tokens/spacing.css';
import '../design-source/ds/tokens/motion.css';
import '../design-source/ds/tokens/base.css';
import './styles/app.css';

import { primeChrome } from './app/chrome';
import { App } from './app/App';

// Set <html> theme/density/motion before first paint to avoid a flash.
primeChrome();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 15_000,
      gcTime: 5 * 60_000,
    },
  },
});

const el = document.getElementById('root');
if (!el) throw new Error('#root not found');

createRoot(el).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
